import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class WorkflowsService {

  apiHost = environment.apiHost;
  signedIn: boolean = this.authService.signedIn;

  constructor(
    private http: HttpClient,
    private authService: AuthService) { }

  getLandingPads(search, workflowId, limit=10): Observable<any> {
    let query = "?search_str=" + encodeURIComponent(search) + "&wf_id=" + workflowId + "&result_size=" + limit + "&order=asc";
    return this.http.get(this.apiHost+"/landingpad"+query).map(
      (data: any) => {
        let total = data.total_landingpads;
        let landingPads = data.landingpads;
        return {landingPads: landingPads, total: total};
      }
    ).catch((error) => {
        console.log("Get landing pads error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(error.status);
      }
    );
  }

  getJellyrollFolders(search, limit=10): Observable<any> {
    let query = "?search_str=" + encodeURIComponent(search) + "&result_size=" + limit
    return this.http.get(this.apiHost+"/jellyroll"+query).map(
      (data: any) => {
        let total = data.total_folders;
        let folders = data.folders;
        return {folders: folders, total: total};
      }
    ).catch((error) => {
        console.log("Get jellyroll folders error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(error.status);
      }
    );
  }

  getNrgTerms(path, search, limit=10): Observable<any> {
    let query = "?path=" + encodeURIComponent(path) +
      "&text=" + encodeURIComponent(search) +
      "&count=" + limit
    if (search.length < 3) {
      query += "&type=begins_with"
    } else {
      query += "&type=contains"
    }
    return this.http.get(this.apiHost+"/nrg"+query).map(
      (data: any) => {
        return data.nrgcache;
      }
    ).catch((error) => {
        console.log("Get nrg terms error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(error.status);
      }
    );
  }

  getJellyrollFilenames(search, limit=10): Observable<any> {
    let query = "?q=" + encodeURIComponent(search) + "&rows=" + limit
    return this.http.get(this.apiHost+"/jellyroll/filenamesearch"+query).map(
      (data: any) => {
        return data;
      }
    ).catch((error) => {
        console.log("Get jellyroll filenames error:"); console.log(error);
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(error.status);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/workflows/workflows.service.ts